import { IRootState } from 'app/store';

export const selectRedirectRoute = (state: IRootState) => state.redirectRoute;
